import { render, staticRenderFns } from "./ExplainBlock.vue?vue&type=template&id=405d1132&scoped=true"
import script from "./ExplainBlock.vue?vue&type=script&lang=js"
export * from "./ExplainBlock.vue?vue&type=script&lang=js"
import style0 from "./ExplainBlock.vue?vue&type=style&index=0&id=405d1132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d1132",
  null
  
)

export default component.exports